import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const PayorsPage = lazy(() => import('./PayorsPage'));

const PayorsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Payments,
  routes: [
    {
      path: 'payors',
      element: <PayorsPage />,
    },
  ],
};

export default PayorsConfig;
